import { HeadProps } from 'gatsby';
import { useSiteMetadata } from '../../hooks/useSiteMetadata';

interface SeoProps {
  slug?: string;
  location?: HeadProps['location'];
  title: string;
  keywords?: string;
  description?: string;
}

export const Seo = ({ slug = '', location, title, keywords = '', description = '' }: SeoProps) => {
  // Get the site metadata
  const {
    description: siteDescription,
    keywords: siteKeywords,
    imageUrl,
    language,
    name,
    firstName,
    lastName
  } = useSiteMetadata();

  // Set the site meta data
  const metaArray = [
    {
      name: 'description',
      content: description || siteDescription
    },
    {
      name: 'keywords',
      content: keywords || siteKeywords
    },
    {
      property: 'og:title',
      content: title
    },
    {
      property: 'og:description',
      content: description
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:url',
      content: slug || location?.pathname || ''
    },
    {
      property: 'og:image',
      content: imageUrl
    },
    {
      name: 'twitter:card',
      content: 'summary'
    },
    {
      name: 'twitter:creator',
      content: firstName + ' ' + lastName
    },
    {
      name: 'twitter:title',
      content: title
    },
    {
      name: 'twitter:description',
      content: description
    }
  ];

  return (
    <>
      <html lang={language} />
      <title>
        {title} | {name}
      </title>
      {metaArray.map((meta) => (
        <meta key={meta.name || meta.property} {...meta} />
      ))}
    </>
  );
};
